// extracted by mini-css-extract-plugin
export default {"toggle-wrapper":"ToggleDeviceRead_toggle-wrapper__rSPhn"};